import React from "react";
import { FiMenu, FiGlobe } from "react-icons/fi";

import "../../styles/DashboardHeader.css";

type Props = {
  userEmail?: string | null;
  initials: string;
  plan: "free" | "premium";

  language: "en" | "sv" | "de" | "fr" | "es";
onChangeLanguage: (
  language: "en" | "sv" | "de" | "fr" | "es"
) => void;

  onUpgrade: () => void;
  onSignIn: () => void;
  onSignOut: () => void;
  onOpenMobileMenu?: () => void;
};

export default function DashboardHeader({
  userEmail,
  initials,
  plan,
  language,
  onChangeLanguage,
  onUpgrade,
  onSignIn,
  onSignOut,
  onOpenMobileMenu,
}: Props) {
  const [profileOpen, setProfileOpen] = React.useState(false);

  return (
    <header className="dashboard-header">
      <div className="dashboard-header__left">
        <button
          type="button"
          className="dashboard-header__menu-button"
          onClick={onOpenMobileMenu}
          aria-label="Open menu"
        >
          {React.createElement(FiMenu as React.ElementType)}
        </button>

        <div>
          <h1>Welcome back!</h1>
          <p>Here’s your career overview</p>
        </div>
      </div>

      <div className="dashboard-header__actions">
        <div className="dashboard-header__language">
          {React.createElement(FiGlobe as React.ElementType)}

          <select
            value={language}
            onChange={(e) =>
              onChangeLanguage(
                e.target.value as "en" | "sv" | "de" | "fr" | "es"
              )
            }
            aria-label="Language"
          >
            <option value="en">English</option>
            <option value="sv">Svenska</option>
            <option value="de">Deutsch</option>
            <option value="fr">Français</option>
            <option value="es">Español</option>
          </select>
        </div>

        <button
          type="button"
          className="dashboard-header__upgrade"
          onClick={onUpgrade}
        >
          Upgrade
        </button>

        {userEmail ? (
          <div className="dashboard-header__profile">
            <button
              type="button"
              className="dashboard-header__avatar"
              onClick={() => setProfileOpen((value) => !value)}
            >
              {initials || "U"}
            </button>

            {profileOpen && (
              <div className="dashboard-header__profile-menu">
                <div>
                  <strong>Signed in as</strong>
                  <span>{userEmail}</span>
                </div>

                <div className="dashboard-header__plan">
                  Plan: <strong>{plan}</strong>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    setProfileOpen(false);
                    onSignOut();
                  }}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        ) : (
          <button
            type="button"
            className="dashboard-header__signin"
            onClick={onSignIn}
          >
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}